export default __webpack_public_path__ + "static/media/certificate.eeff7ddd.pdf";